import { useState } from "react";
import { observer } from "mobx-react";
import { AddCircle, CloseSquare } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '../../icons/save-icon.png';
import RoundButton from "../../content/shared/components/round-btn";
import styles from "../my-data.module.scss";

const AddCustomFieldModal = observer(({ uiStore, section, updateData, category, handleEditModeCollapse, type }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [value, setValue] = useState('');

    const save = async () => {
        setLoading(true);
        const data = await uiStore.addCustomField(category, section, value);
        updateData(data);
        setLoading(false);
        setShow(false);
        if (handleEditModeCollapse)
            handleEditModeCollapse(type, true);
    }

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    return (
        <Box>
            {category.name === 'Dates' || category.name === 'Relationships' ?
                <LoadingButton
                    sx={{ borderRadius: '100px', mr: 1 }}
                    loading={!!loading}
                    onClick={() => setShow(true)}
                    variant="contained"
                    color="lightblue"
                    className={`${styles.mydataEditBtn} ${styles.hideInMobile}`}
                >
                    <AddCircle
                        size="24"
                        variant="Bulk"
                    />
                    <Box className={styles.hideText} sx={{ ml: 1 }}>New</Box>
                </LoadingButton>
                :
                <RoundButton
                    startIcon={
                        <AddCircle
                            size="24"
                            variant="Bulk"
                        />
                    }
                    variant="contained"
                    color="lightblue"
                    sx={{ mb: 3, mt: 3 }}
                    onClick={() => setShow(true)}
                    size='small'
                >
                    Add Custom Field
                </RoundButton>


            }


            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px', width: '370px' }, variant: 'round' }}
            >
                <DialogTitle>
                    {category.name === 'Dates' ? 'Add New Date' : 'Add Custom Field'}
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        fullWidth
                        sx={{ margin: '20px 0' }}
                        value={value}
                        disabled={loading}
                        onChange={handleChange}
                        label={category.name === 'Dates' ? 'Date Field Name' : 'Custom Field name'}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={save} variant="contained" color="secondary"
                        endIcon={
                            <img src={SaveIcon}
                                alt='Save icon'
                                width={24}
                            />
                        }
                    >
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box >
    );
});

export default AddCustomFieldModal;
